import React from 'react';
import { SectionHeading } from './SectionHeading';
import type { ProductStep } from '../../types/product';
type HowItWorksProps = {
  heading: string;
  items: ProductStep[];
};
export function HowItWorks({
  heading,
  items
}: HowItWorksProps) {
  return <section className="w-full bg-canvas-sky py-20" aria-labelledby="how-heading" data-id="element-1060" data-mp="339uebhlacyiu">
      <div className="mx-auto max-w-shell px-6" data-id="element-1061" data-mp="37e229cjx6ag0">
        <SectionHeading id="how-heading" title={heading} data-id="element-1062" data-mp="3v3d0ondsrsqz" />
        <ol className="relative mt-14 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8" data-id="element-1063" data-mp="3v3wjs7f6on6l">
          <span aria-hidden="true" className="absolute left-[18px] right-[18px] top-[18px] hidden h-px bg-canvas-skyline md:block" data-id="element-1064" data-mp="3wa9hvxylmgr" />
          {items.map((step, index) => <li key={step.title} className="relative" data-id="element-1065" data-mp="3qzosc2hcct4o" data-mpi={index}>
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-brand text-[14px] font-semibold text-white ring-4 ring-canvas-warm" data-id="element-1066" data-mp="2an05xj1qtplq">
                {index + 1}
              </span>
              <h3 className="mt-5 text-[19px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1067" data-mp="1jpp19kfgmq89">{step.title}</h3>
              <p className="mt-2 max-w-[320px] text-[15px] leading-[1.55] text-ink-muted" data-id="element-1068" data-mp="1er48u76g9aud">{step.copy}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}